import api from '../api';

const END_POINT = "/api/interventions";

/**
 * This method will send interventions between the two dates selected in an email to each person selected. Everybody will receive only their own interventions.
 * 
 * @param  {Object - mailingList} mailingList having usersId, dateStart, dateEnd
 * @returns {} it is returning a promise. Need to check if status 200 to know if emails have been sent
 */
export async function getSendEmailToEmployeesHttp(mailingList) {
    return await api.post(`${END_POINT}/email/employees`, 
        {
            usersId: mailingList.usersId,
            dateStart: mailingList.dateStart,
            dateEnd: mailingList.dateEnd
        }
    );
}